module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-67596e162071894f705abb4ace14bfa9.png";